module.exports = __webpack_public_path__ + "static/media/phone (11).0666f883.svg";